<template>
  <div class="main" id="fenxibaogao" :class="{ pprint: isprint }">
    <selectTool ref="selectTool" v-show="!isprint"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun">查询</Button
        ><Button @click="dayin" type="primary" class="chaxun"
          >打印</Button
        ></template
      ></selectTool
    >
    <Card id="mycard">
      <h1 style="margin-bottom: 50px">风控运营智能分析报告</h1>

      <jichuxinxi ref="jichuxinxi" :name="searchItem.name"
        ><span slot="right">{{ startToEnd }}</span></jichuxinxi
      >
      <kaohezhibiao ref="kaohezhibiao"
        ><span slot="right">{{ startToEnd }}</span></kaohezhibiao
      >
      <lichengfenxi ref="lichengfenxi"
        ><span slot="right">{{ startToEnd }}</span></lichengfenxi
      >
      <baojingfenxi ref="baojingfenxi"
        ><span slot="right">{{ startToEnd }}</span></baojingfenxi
      >
      <baojingjibie ref="baojingjibie"
        ><span slot="right">{{ startToEnd }}</span></baojingjibie
      >
      <baojingduibi ref="baojingduibi"
        ><span slot="right">{{ startToEnd }}</span></baojingduibi
      >
      <baojingpaiming ref="baojingpaiming"
        ><span slot="right">{{ startToEnd }}</span></baojingpaiming
      >
      <zhongdianfengxian ref="zhongdianfengxian"
        ><span slot="right">{{ startToEnd }}</span></zhongdianfengxian
      >
      <fengxiananli ref="fengxiananli"
        ><span slot="right">{{ startToEnd }}</span></fengxiananli
      >

      <jianyi ref="jianyi"></jianyi>
    </Card>
  </div>
</template>
<script>
import jichuxinxi from "./anaReports/jichuxinxi.vue";
import kaohezhibiao from "./anaReports/kaohezhibiao.vue";
import lichengfenxi from "./anaReports/lichengfenxi.vue";
import baojingfenxi from "./anaReports/baojingfenxi.vue";
import baojingduibi from "./anaReports/baojingduibi.vue";
import baojingjibie from "./anaReports/baojingjibie.vue";
import baojingpaiming from "./anaReports/baojingpaiming.vue";
import zhongdianfengxian from "./anaReports/zhongdianfengxian.vue";
import fengxiananli from "./anaReports/fengxiananli.vue";
import jianyi from "./anaReports/jianyi.vue";

export default {
  components: {
    lichengfenxi,
    jichuxinxi,
    kaohezhibiao,
    baojingfenxi,
    baojingduibi,
    baojingjibie,
    baojingpaiming,
    zhongdianfengxian,
    fengxiananli,
    jianyi,
  },
  data() {
    return {
      isprint: false,
      searchItem: {
        endTime: "",
        groupIdList: [],
        name: "深圳来源电子有限公司",
        startTime: "",
      },
      searchForms: [
        {
          title: "选择单位",
          key: "groupIdList",
          key1: "name",
          type: "selectGroups",
        },
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          type: "lyyymmdd",
          times: "2,0",
        },
      ],
      startToEnd: "",
    };
  },
  methods: {
    dayin() {
      this.isprint = true;

      setTimeout(() => {
        window.print();
        this.isprint = false;
      }, 500);

      // //var alcd=document.getElementById('alcd');
      // //this.$refs.dayin.reach(alcd);
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      if (this.searchItem.groupIdList.length == 0) {
        this.$Message.error("单位必填");
        return;
      }
      this.startToEnd =
        this.utils.time(this.searchItem.startTime, "yymmdd") +
        "至" +
        this.utils.time(this.searchItem.endTime, "yymmdd");
      //this.getList();
      this.$refs.jichuxinxi.getData(this.searchItem);
      this.$refs.kaohezhibiao.getData(this.searchItem);
      this.$refs.lichengfenxi.getData(this.searchItem);
      this.$refs.baojingfenxi.getData(this.searchItem);
      this.$refs.baojingduibi.getData(this.searchItem);
      this.$refs.baojingjibie.getData(this.searchItem);
      this.$refs.baojingpaiming.getData(this.searchItem);
      this.$refs.fengxiananli.getData(this.searchItem);
      this.$refs.zhongdianfengxian.getData(this.searchItem);
      this.$refs.zhongdianfengxian.getData1(this.searchItem);

      this.$refs.jianyi.getData(this.searchItem);
    },
  },
  mounted() {
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
  },
  watch: {
    isprint(v) {
      setTimeout(() => {
        this.$refs.lichengfenxi.drawBar();
        this.$refs.baojingfenxi.drawBar();
      }, 100);
    },
  },
};
</script>
<style>
.pprint {
  position: absolute;
  left: 0;
  top: 0;
  background: white;
  margin-top: 0 !important;
  height: 100% !important;
  width: 100% !important;
  z-index: 222;
}

#fenxibaogao h1 {
  text-align: center;
  margin-top: 50px;
}
#fenxibaogao h3 {
  margin-bottom: 30px;
  border-bottom: solid 2px #5aa4f3;
  padding-bottom: 6px;
  display: flex;
}
#fenxibaogao h3 span {
  margin-left: auto;
  margin-top: 6px;
}
#fenxibaogao .boxes {
  margin: 20px 0;
  width: 100%;
}

#mycard {
  border: solid 15px #e4e4e4;
}

.pprint #mycard {
  width: 1500px;
  border: solid 15px #fff;
}
#fenxibaogao .boxes h3 i {
  color: #3d88ff;
  margin-right: 6px;
}
</style>


// WEBPACK FOOTER //
// src/components/dataAnalyse/anaReport.vue